export var termsStore = [];
var termObservers = [];
export function subscribeToTermStore(callBack) {
    termObservers.push(callBack);
}
export function addTermIntoStore(term) {
    termsStore.push(term);
    termObservers.forEach(function(observer) {
        return observer(termsStore);
    });
}
export function unsubscribeFromTermStore(callBack) {
    termObservers = termObservers.filter(function(observer) {
        return observer !== callBack;
    });
}

//# sourceMappingURL=termsObserver.js.map